import Keycloak from 'keycloak-js';

const keycloak = new Keycloak({
  url: 'https://keycloakpacs.xylexa.ai/keycloak',
  realm: 'orthanc',
  clientId: 'orthanc',
});

export default keycloak;
